import { RouteHttpVerb } from "@devowl-wp/utils";
const locationRestPluginUpdateSkipPost = {
    path: "/plugin-update/:slug/skip",
    method: RouteHttpVerb.POST
};
export { locationRestPluginUpdateSkipPost };
